import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');
import { BaseReport } from './BaseReport';

export class BalanceSheetReport extends BaseReport {
    _originalTypeClassName = "zERP.BO.BalanceSheetReport";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
BalanceSheetReport.translate = translateService;
}
super();
this.Active = [];
this.Passive = [];
this._key = this.BaseReportKey = 0; 
}

static translate: TranslateService;
_key: any;
Active:any;
Passive:any;
static setActive = ($this, items) => {
                if (items == null) items = [];
                if ($this.Active == null) $this.Active = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Active.length > 0) {
                    Domain.BalanceSheetReport.removeActive($this, $this.Active[0]);
                }

                Domain.BalanceSheetReport.addManyActive($this, copyItems);
            }
static addManyActive = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.BalanceSheetReport.addActive($this, items[i]);
                }
            }
static addActive = ($this, item) => {
                if ($this.Active == null) $this.Active = [];
                if (item == null || $this.Active.indexOf(item) > -1) return;
                $this.Active.push(item);
}
static addRangeActive = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.BalanceSheetReport.addActive($this, item));
            }
static removeActive = ($this, item) => {
                if ($this == null || $this.Active == null || $this.Active.indexOf(item) === -1) return;
                var _index = $this.Active.indexOf(item);
                $this.Active.splice(_index, 1);
}
static clearActive = ($this) => { $this.Active = null; }
static setPassive = ($this, items) => {
                if (items == null) items = [];
                if ($this.Passive == null) $this.Passive = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Passive.length > 0) {
                    Domain.BalanceSheetReport.removePassive($this, $this.Passive[0]);
                }

                Domain.BalanceSheetReport.addManyPassive($this, copyItems);
            }
static addManyPassive = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.BalanceSheetReport.addPassive($this, items[i]);
                }
            }
static addPassive = ($this, item) => {
                if ($this.Passive == null) $this.Passive = [];
                if (item == null || $this.Passive.indexOf(item) > -1) return;
                $this.Passive.push(item);
}
static addRangePassive = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.BalanceSheetReport.addPassive($this, item));
            }
static removePassive = ($this, item) => {
                if ($this == null || $this.Passive == null || $this.Passive.indexOf(item) === -1) return;
                var _index = $this.Passive.indexOf(item);
                $this.Passive.splice(_index, 1);
}
static clearPassive = ($this) => { $this.Passive = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.BaseReportKey == null || $this.BaseReportKey == 0;
            }


}